import type { RouteObject } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

const CreatePriorityList = lazyNamed(
  () => import("./create-priority-list"),
  "CreatePriorityList",
);
const PriorityList = lazyNamed(() => import("./priority-list"), "PriorityList");
const PriorityLists = lazyNamed(
  () => import("./priority-lists"),
  "PriorityLists",
);

export const routes: Array<RouteObject> = [
  {
    path: "priority-lists",
    element: <PriorityLists />,
    spacesAccess: "hidden-from-limited-view",
  },
  {
    path: "priority-lists/new",
    element: <CreatePriorityList />,
    spacesAccess: "hidden-from-limited-view",
  },
  {
    path: "priority-lists/:priority_list_id",
    element: <PriorityList />,
    spacesAccess: "hidden-from-limited-view",
  },
];
